module.exports = __webpack_public_path__ + "static/img/technologybg1.c06f7321.png";